//DashboardLayout.js
import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import MainLayout from './MainLayout';
import CargandoPantalla from '../Utils/CargandoPantalla';

const DashboardLayout = () => {
    return (
        <MainLayout>
            <div className="dashboard-content" style={{ width: '100%', height: '100%' }}>
                {/* Las pantallas se cargan con React.lazy (App.js): el menú queda visible mientras bajan */}
                <Suspense fallback={<CargandoPantalla />}>
                    <Outlet />
                </Suspense>
            </div>
        </MainLayout>
    );
};
export default DashboardLayout;


